<template>
  <ul class="pagination" style="margin: 0" name="Pagination">
    <li v-if="!isFirstPage" class="page-item" @click="turnPage(-1)">
      <a href="#" class="page-link" @click.prevent>
        <i class="fa fa-arrow-left"></i>
      </a>
    </li>
    <li v-for="i in dspBtnObjs" :class="['page-item', { 'active': i.btn === curPage }]" :key="i.i">
      <a v-if="i.btn" href="#" class="page-link" @click.prevent="handleClick(i.btn)">
        {{ i.btn }}
      </a>
      <a v-else class="page-link">
        <i class="fa fa-ellipsis-h"></i>
      </a>
    </li>
    <li v-if="!isLastPage" class="page-item" @click="turnPage(1)">
      <a href="#" class="page-link" @click.prevent>
        <i class="fa fa-arrow-right"></i>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    total: { type: Number, required: true },
    query: { type: Object, required: true }
  },
  computed: {
    isFirstPage () {
      return +this.query.offset === 0 || +this.query.limit >= this.total
    },
    isLastPage () {
      return +this.query.offset + +this.query.limit >= this.total
    },
    totalPage () {
      return Math.ceil(this.total / +this.query.limit)
    },
    curPage () {
      return Math.ceil(+this.query.offset / +this.query.limit) + 1
    },
    dspBtns () {
      const n = this.totalPage
      const i = this.curPage

      /* eslint-disable */
      if (n <= 9) return ((n) => {
        const arr = Array(n)
        while (n) { arr[n - 1] = n-- }
        return arr
      })(n)
      if (i <= 5) return [1, 2, 3, 4, 5, 6, 7, 0, n] // 0 represents `···`
      if (i >= n - 4) return [1, 0, n-6, n-5, n-4, n-3, n-2, n-1, n]
      return [1, 0, i-2, i-1, i, i+1, i+2, 0, n]
      /* eslint-enable */
    },
    dspBtnObjs () {
      return this.dspBtns.map(function (btn, i) {
        return { btn, i }
      })
    }
  },
  methods: {
    handleClick (n) {
      this.query.offset = (n - 1) * +this.query.limit
      this.query.nChanges += 1
    },
    turnPage (i) {
      this.query.nChanges += 1
      if ((i < 0 && this.isFirstPage) || (i > 0 && this.isLastPage)) return
      this.query.offset = +this.query.offset + i * +this.query.limit
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatable/src/Pagination.vue